import React from 'react';
import { Link } from 'react-scroll';
import FullPageSection from './FullPageSection';
import './HeroSection.css';

const HeroSection = () => {
    return (
        <FullPageSection id="hero" className="hero-section">
            <div className="hero-background">
                <img
                    src="https://images.unsplash.com/photo-1502810190503-8303352d0dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3NzA0MjYwNzF8MA&ixlib=rb-4.1.0&q=85"
                    alt="Creative workspace"
                    className="hero-image"
                />
                <div className="hero-overlay"></div>
            </div>

            <div className="hero-content">
                <h1 className="hero-title">
                    Desenhamos<br />
                    Marcas<br />
                    Fortes
                </h1>
                <p className="hero-subtitle">
                    MAPDESIGN — creative studio
                </p>
                <div className="hero-cta">
                    <Link to="portfolio" smooth duration={800} className="btn-primary">
                        Ver Portfolio
                    </Link>
                    <Link to="contact" smooth duration={800} className="btn-secondary">
                        Contacto
                    </Link>
                </div>
            </div>

            <div className="scroll-indicator">
                <div className="scroll-arrow"></div>
            </div>
        </FullPageSection>
    );
};

export default HeroSection;
